import React, { FC } from "react";
import { RouteComponentProps, Switch, Redirect } from "react-router-dom";
import {
  SURVEY_BASE_PATH,
  SURVEY_LEADER_PATH,
} from "src/app/modules/Survey/constants";
import { NOT_FOUND_ERROR_PAGE_PATH } from "src/app/common/constants";
import PruRoute from "src/app/common/components/PruRoute";
import ParamsProvider from "src/app/common/components/ParamsProvider";
import { surveyFilterKeys } from "src/app/modules/Survey/pages/Management/List/SurveyListingPage";
import AgentLeaderSurveyListingPage from "./List/AgentLeaderSurveyListingPage";
import AgentLeaderSurveyDetailPage from "./Create/AgentLeaderSurveyDetailPage";
import AgentLeaderSurveyAnalyticPage from "./Analytics/AgentLeaderSurveyAnalyticPage";

const AgentLeaderSurveyManagementPage: FC<RouteComponentProps> = ({ history }) => {
  return (
    <Switch>
      <Redirect
        exact
        from={`${SURVEY_BASE_PATH}${SURVEY_LEADER_PATH}`}
        to={`${SURVEY_BASE_PATH}${SURVEY_LEADER_PATH}/list`}
      />
      <PruRoute
        exact
        path={`${SURVEY_BASE_PATH}${SURVEY_LEADER_PATH}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={surveyFilterKeys}>
            <AgentLeaderSurveyListingPage />
          </ParamsProvider>
        )}
      />
      <PruRoute
        exact
        path={`${SURVEY_BASE_PATH}${SURVEY_LEADER_PATH}/edit/:id`}
        component={AgentLeaderSurveyDetailPage}
      />
      <PruRoute
        exact
        path={`${SURVEY_BASE_PATH}${SURVEY_LEADER_PATH}/create`}
        component={AgentLeaderSurveyDetailPage}
      />
      <PruRoute
        exact
        path={`${SURVEY_BASE_PATH}${SURVEY_LEADER_PATH}/:id/results`}
        component={AgentLeaderSurveyAnalyticPage}
      />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default AgentLeaderSurveyManagementPage;
